import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsdoc/require-jsdoc */
import { Component } from "react";
import { FloatLineComponent } from "shared-ui-components/lines/floatLineComponent.js";
import { SliderLineComponent } from "shared-ui-components/lines/sliderLineComponent.js";
/**
 * A simple float slider component
 */
export class FloatSliderComponent extends Component {
    // eslint-disable-next-line babylonjs/available
    constructor(props) {
        super(props);
        this.state = { displaySlider: false };
    }
    /**
     * Trigger update when props change
     * @param prevProps - The previous props
     */
    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.forceUpdate();
        }
    }
    // eslint-disable-next-line babylonjs/available
    render() {
        const canUseSlider = !this.props.forceSliderOff && this.props.min !== null && this.props.max !== null && this.props.min < this.props.max;
        // Ensure the value is within the min/max range
        if (canUseSlider) {
            this.props.target[this.props.propertyName] = Math.max(this.props.min, Math.min(this.props.max, this.props.target[this.props.propertyName]));
        }
        return (_jsxs(_Fragment, { children: [!canUseSlider && (_jsx(FloatLineComponent, { lockObject: this.props.lockObject, label: this.props.label, target: this.props.target, propertyName: this.props.propertyName, onChange: () => {
                        this.props.onChange();
                    } })), canUseSlider && (_jsx(SliderLineComponent, { lockObject: this.props.lockObject, label: this.props.label, target: this.props.target, propertyName: this.props.propertyName, step: Math.abs(this.props.max - this.props.min) / 100.0, minimum: this.props.min, maximum: this.props.max, onChange: () => {
                        this.props.onChange();
                    } }))] }));
    }
}
//# sourceMappingURL=floatSliderComponent.js.map